<script>
    import Select from "svelte-select/Select.svelte";
    import { Steps } from 'svelte-steps';
    import { onMount, getContext } from "svelte";
    import { apiMethods } from "../../../Services/index.svelte";
    import { shouldResetRebateTableDropdowns } from './resetStore';
    import { getEmailValidation } from "../../../Utils/utilFunctions.svelte";
    import {
        addErrorInput,
        removeErrorInput,
    } from "../../../Pages/PatientEncounter/helpers/encounterUtils.svelte";
    import NoGapProgramSpecialRules from "./NoGapProgramSpecialRules.svelte";
    import NoGapProgramRule from "./NoGapProgramRule.svelte";

    export let 
            hospitalId,
            handleSearchSurgeon,
            stepIndex,
            selectedInsuranceFund,
            noGapInsuranceFunds,
            allSurgeonsSelected,
            selectedSurgeons,
            noGapSurgeons,
            isUpliftInvoice,
            upliftInvoiceEmail,
            specialRules,
            defaultRule,
            selectedRebateTable,
            fallbackRebateTable,
            mbsItems;
    
    let filterBySpecialityCodes = true,
        specialRulesRef,
        defaultRuleRef;
    let errInputs = [];
    let hospitalFundNoGapProgramNames = [];

    onMount(() => {
        if(selectedInsuranceFund) {
            loadHospitalFundNoGapProgramNames(hospitalId, selectedInsuranceFund.key);
        }

    });

    export const checkNoGapProgramValidation = (stepIndex) => {
        errInputs = [];

        _updateInvalidFieldsStyle(stepIndex);

        return errInputs == 0; 
    };

    const _updateInvalidFieldsStyle = (stepIndex) => {
        //do validation step by step
        if(stepIndex == 0){
            if(!selectedInsuranceFund){
                errInputs = addErrorInput(
                    "selectedInsuranceFundId",
                    errInputs,
                    "Insurance Fund",
                );
            }
            if(!allSurgeonsSelected && (!selectedSurgeons || selectedSurgeons.length == 0)){
                errInputs = addErrorInput(
                    "selectedSurgeons",
                    errInputs,
                    "Selected surgeons",
                );
            }
            if(isUpliftInvoice ) {
                if(upliftInvoiceEmail == "" || upliftInvoiceEmail == null) {
                    errInputs = addErrorInput(
                        "upliftInvoiceEmail",
                        errInputs,
                        "Uplift invoice email",
                    );
                } else {
                    const isValidEmail = getEmailValidation(upliftInvoiceEmail.trim());
                    if(!isValidEmail){
                        errInputs = addErrorInput(
                            "upliftInvoiceEmail",
                            errInputs,
                            "Uplift invoice email",
                        );
                    }
                }
            }
            //basic settings
        } else if (stepIndex == 1) {
            //default case
            if(selectedInsuranceFund && !selectedRebateTable) {
                errInputs = addErrorInput(
                    "selectedRebateTable",
                    errInputs,
                    "Fallback rebate table",
                );
            }

            //default rule not mandatory anymore
          /*   const defaultRuleCheckErrors =
                defaultRuleRef.checkNoGapProgramRuleValidation();
            errInputs = [...errInputs, ...defaultRuleCheckErrors]; */

        } else if (stepIndex == 2) {
            //special rules
            const specialRulesCheckErrors =
                specialRulesRef.checkNoGapProgramSpecialRulesValidation();
            errInputs = [...errInputs, ...specialRulesCheckErrors];

        }
      
    };

    const loadHospitalFundNoGapProgramNames = async (
       hospitalId, fundId
    ) => {

        await apiMethods.getMethod
            .getNoGapProgramNames(hospitalId, fundId)
            .then((res) => {
                hospitalFundNoGapProgramNames = res.map((name) => ({
                        key: name == "" ? "" : name,
                        label: name == "" ? "Default" : name
                    }));
            });

    };

    const FALLBACK_REBATE_TABLES = getContext('FALLBACK_REBATE_TABLES');

    $: fallBackRebateTablesByFund = (() => {
        if (selectedInsuranceFund != null) {
            const fundRelatedRebateTables = FALLBACK_REBATE_TABLES.filter(r => r.hcpCode === selectedInsuranceFund.hcpCode);
            const notFundRelatedRebaleTables = FALLBACK_REBATE_TABLES.filter(r => r.hcpCode === "");
            if (fundRelatedRebateTables.length > 0) {
                return [...notFundRelatedRebaleTables, ...fundRelatedRebateTables];
            }
        }
        return [ ...FALLBACK_REBATE_TABLES];
    })();

    const clearCurrentFund = () => ( selectedInsuranceFund = null );
    const clearSelectedFallbackRebate = () => ( selectedRebateTable = null, fallbackRebateTable = null );
    const removeSurgeonsFromList = (deletedSurgeons) => ( 
        selectedSurgeons = selectedSurgeons.filter((s) => !deletedSurgeons.map((sp) => sp.key).includes(s.key))
    );

    let steps = [
        { text: 'Basic Settings' },
        { text: 'Default Case' },
        { text: 'Special Cases' },
        { text: 'Summary' },
    ];

    const getRuleDescription = (ruleGroup) => {
        return `${ruleGroup.rebateType == 2 ? 'Uplift with' : 'Unit value of'} ${ruleGroup.rebateType == 2 ? `${ruleGroup.upliftRebate == "" ? "Default fees" : ruleGroup.upliftRebate}` : `$${ruleGroup.unitValue}`} (${ruleGroup.itemNums.map(i => i).join(", ")})`;
    }

    const getDefaultRuleDescription = () => {
        return defaultRule.rebateType == 0 ? "Not set" : `${defaultRule.rebateType == 2 ? 'Uplift' : 'Unit value of'} ${defaultRule.rebateType == 2 ? `(${defaultRule.upliftRebate == "" ? "Default fees" : defaultRule.upliftRebate})` : `$${defaultRule.unitValue}`}`;
    }
</script> 

<div class="w-full flex flex-col gap-y-3">
    <Steps 
        {steps} 
        on:click={(ev) => {
            let nextIndex = ev.detail.current
            if(nextIndex > stepIndex){
                if(nextIndex - stepIndex > 1){
                    if(checkNoGapProgramValidation(stepIndex)) {
                        stepIndex = stepIndex +1;
                    } else {
                        stepIndex = nextIndex;
                        stepIndex = ev.detail.last;
                        return;
                    }
                } else {
                    //validate prev stepp
                    if(checkNoGapProgramValidation(stepIndex)) {
                        stepIndex = nextIndex;
                    } else {
                        stepIndex = nextIndex;
                        stepIndex = ev.detail.last;
                        return;
                    }
                }
                
            } else {
                stepIndex = nextIndex;
            }
        }}
        current={stepIndex}
        primary="rgb(137, 61, 214)" 
        secondary="#e5e7eb" 
        size="2rem" 
        line="2px"/>

    {#if stepIndex == 0}
        <div class="w-full flex flex-col justify-center">
            <div class="pt-3 pb-3 italic">
                * Please select insurance fund, participating surgeons and submission type
            </div>
            <p>Insurance Fund:</p>
            <div class="w-full rounded-md" id="selectedInsuranceFundId">
                <Select
                    bind:value={selectedInsuranceFund}
                    items={noGapInsuranceFunds}
                    itemId="key"
                    label="value"
                    on:clear={clearCurrentFund}
                    on:change={(ev) => {
                        loadHospitalFundNoGapProgramNames(hospitalId, selectedInsuranceFund.key)
                        clearSelectedFallbackRebate();
                        shouldResetRebateTableDropdowns.set(true);
                        errInputs = removeErrorInput(
                            "selectedInsuranceFundId",
                            errInputs,
                            "Insurance Fund",
                        );
                    }}
                    noOptionsMessage="No Insurance Funds Found"
                    placeholder="Select Insurance Fund"
                />
            </div>
        </div>
        <div class="w-full flex flex-col justify-center gap-y-1">
            <p>Surgeons:</p>
            <div class="w-full flex flex-row gap-2">
                <input
                    type="checkbox"
                    class="toggle toggle-secondary"
                    bind:checked={allSurgeonsSelected}
                    id="allSurgeonsSelected"
                /> All surgeons
            </div>
            {#if !allSurgeonsSelected}
                <div class="w-full rounded-md mt-2" id="selectedSurgeons">
                    <Select
                        bind:value={selectedSurgeons}
                        loadOptions={(searchText) => handleSearchSurgeon(searchText, filterBySpecialityCodes)} 
                        items={noGapSurgeons}
                        multiple={true}
                        itemId="key"
                        label="value"
                        on:clear={(ev) => { removeSurgeonsFromList(ev.detail) }}
                        on:change={(ev) => {
                            errInputs = removeErrorInput(
                                "selectedSurgeons",
                                errInputs,
                                "Surgeons",
                            );
                        }}
                        noOptionsMessage="No surgeon found"
                        placeholder="Select surgeons"
                    />
                </div>
                <div class="flex items-center gap-2 min-h-[42px] h-auto mr-2">
                    <input
                      type="checkbox"
                      id={`filterBySpeciality`}
                      class={`checkbox checkbox-secondary checkbox-xs cursor-pointer`}
                      on:click={() => {
                        filterBySpecialityCodes = !filterBySpecialityCodes;
                      }}
                      checked={filterBySpecialityCodes}
                    />
                    <label class="whitespace-nowrap cursor-pointer w-full pt-1">
                        Filter for procedural speciality
                    </label>
                  </div>
            {/if}
        </div>
        <div class="w-full flex flex-col justify-center gap-y-1">
            <p>Submission via Eclipse:</p>
            <div class="w-full flex flex-row gap-2 items-center">
                <input
                    type="checkbox"
                    class="toggle toggle-secondary"
                    bind:checked={isUpliftInvoice}
                    id="allSurgeonsSelected"
                /> Uplift Invoice
                {#if isUpliftInvoice}
                    <div class="w-full flex-1">
                        <input
                            type="text"
                            id="upliftInvoiceEmail"
                            placeholder="Uplift invoice email"
                            class="input w-full input-sm input-bordered h-10"
                            autocomplete="off"
                            on:focus={() => {
                                errInputs = removeErrorInput(
                                    "upliftInvoiceEmail",
                                    errInputs,
                                    "Uplift invoice email",
                                );
                            }}
                            bind:value={upliftInvoiceEmail}
                        />
                    </div>
                {/if}
            </div>
        </div>
    {:else if stepIndex == 1}
        <div class="pt-3 pb-3 italic">
            * Select the default rebate type and values for items not covered by special cases
        </div>
        <div class="w-full flex flex-col justify-center">
            <p>Default case rule:</p>
            <NoGapProgramRule
                bind:this={defaultRuleRef}
                bind:hospitalFundNoGapProgramNames={hospitalFundNoGapProgramNames}
                identifier="defaultRule"
                bind:itemNum={defaultRule.itemNum}
                bind:rebateType={defaultRule.rebateType}
                bind:unitValue={defaultRule.unitValue}
                bind:upliftRebate={defaultRule.upliftRebate}
                bind:selectedInsuranceFund={selectedInsuranceFund}
                onRemove={null}
                onRebateTypeChange={(rebate) => {
                    if(rebate.key == 1){
                        //unit value
                        defaultRule.upliftRebate = null;
                    }
                    if(rebate.key == 2) {
                        //uplift
                        defaultRule.unitValue = 0;
                    }
                }}
            />
        </div>
        <div class="w-full flex flex-col justify-center">
            <p>Fallback rebate table:</p>
            <div class="w-full flex flex-row gap-2 items-center rounded-md" id="selectedRebateTable" >
                <Select
                    bind:value={selectedRebateTable}
                    items={fallBackRebateTablesByFund}
                    itemId="key"
                    disabled={selectedInsuranceFund == null}
                    label="label"
                    on:change={(ev) => {
                        selectedRebateTable = ev.detail;
                        fallbackRebateTable = ev.detail.key;
                        errInputs = removeErrorInput(
                            "selectedRebateTable",
                            errInputs,
                            "Fallback rebate table",
                        );
                    }}
                    on:clear={clearSelectedFallbackRebate}
                    noOptionsMessage="No rebate table found"
                    placeholder="Select rebate table"
                />
            </div>
            <div class="italic pt-3">
                * For item numbers not covered by default or special case uplift rules
            </div>
        </div>
    {:else if stepIndex == 2}
        <div class="pt-3 pb-3 italic">
            * Configure special rebates for specific item numbers. Item numbers not listed will fallback to the fallback rebate (see Default Case). Only one special case can apply for an encounter. If no special case apply the default case will be used.
        </div>
        <NoGapProgramSpecialRules 
            bind:hospitalFundNoGapProgramNames={hospitalFundNoGapProgramNames}
            bind:this={specialRulesRef}
            bind:specialRules={specialRules} 
            bind:selectedInsuranceFund={selectedInsuranceFund}
            mbsItems={mbsItems}>
        </NoGapProgramSpecialRules>
    {:else}
        <div class="font-bold pt-6">
            Basic settings
        </div>
        <div>
            Fund: {selectedInsuranceFund?.value}
        </div>
        <div>
            Surgeons: {allSurgeonsSelected ? "All Surgeons" : `${selectedSurgeons.map((s) => s.value).join(", ")}`}
        </div>
        <div>
            Submission type: {isUpliftInvoice ? `ECLIPSE + Invoice (${upliftInvoiceEmail})` : "ECLIPSE"}
        </div>
        <div class="font-bold">
            Default case
        </div>
        <div>
            Rule: {getDefaultRuleDescription()}
        </div>
        <div>
            Fallback rebate: {fallbackRebateTable}
        </div>
        <div class="font-bold">
            Special cases
        </div>
        {#each specialRules as rule, index (index)}
            <div>
                {getRuleDescription(rule)}
            </div>
        {/each}
        
    {/if}
    
</div>

<style>
    :global(.steps__label) {
        font-size: 14px !important;
    }
</style>